import {
  groupNameMap,
  statusNames,
  vhcCheckBrakeItemNames,
  vhcCheckItemNames,
  vhcCheckWheelTyreItemNames,
  vhcRecordItemGroupsOrders
} from './model/constants';
import { defaultVhcItems } from './model/utils';
import { VHCRecordItemGroups } from 'api/generated';
import { VhcItem } from 'features/vhc/model';
import { useEffectiveItems } from 'features/vhc/model/useEffectiveItems';
import { useMemo } from 'react';

export const groupNamesOrder = [
  {
    group: VHCRecordItemGroups.ExternalOrDriveIn,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.Internal,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.UnderBonnet,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.Underside,
    names: vhcCheckItemNames
  },
  {
    group: VHCRecordItemGroups.BrakesAndHubs,
    names: vhcCheckBrakeItemNames
  },
  {
    group: VHCRecordItemGroups.WheelsAndTyres,
    names: vhcCheckWheelTyreItemNames
  }
];

export const useVhcList = () => {
  const effectiveItems = useEffectiveItems();

  const order = defaultVhcItems.map((i) => `${i.type}_${i.group}`);
  effectiveItems.sort((a, b) => {
    const aKey = `${a.type}_${a.group}`;
    const bKey = `${b.type}_${b.group}`;
    return order.indexOf(aKey) - order.indexOf(bKey);
  });

  const groupedItems = useMemo(() => {
    const result = {} as Record<number, typeof effectiveItems>;

    effectiveItems.forEach((item) => {
      if (item.group !== undefined) {
        if (!result[item.group]) {
          result[item.group] = [];
        }
        result[item.group].push(item);
      }
    });

    const keys = Object.keys(result).map((x) => Number(x));

    if (!keys?.length) return result;

    for (const key of keys) {
      const orderArr: number[] = vhcRecordItemGroupsOrders[key];

      if (!orderArr?.length) continue;

      const ORDER_INDEX = new Map(orderArr.map((t, i) => [t, i]));

      result[key].sort(
        (a, b) =>
          (ORDER_INDEX.get(a.type!) ?? Number.MAX_SAFE_INTEGER) - (ORDER_INDEX.get(b.type!) ?? Number.MAX_SAFE_INTEGER)
      );
    }

    return result;
  }, [effectiveItems]);

  const getGroupedItems = (group: VHCRecordItemGroups) => {
    const items = groupedItems[group] || [];
    const groupName = groupNameMap[group];

    return { items, groupName };
  };

  const getItemInfo = (item: VhcItem, names: any) => {
    const recordName = item.type !== undefined ? names[item.type] : '';
    const conditionName = (item.conditionId && statusNames[item.conditionId]) || '';

    return { recordName, conditionName };
  };

  return {
    getGroupedItems,
    getItemInfo
  };
};
